'use client';

import { createContext, useContext, useLayoutEffect, useMemo, useState } from 'react';
import { readSidebarCollapsed, writeSidebarCollapsed } from '@/utils/sidebarCollapsed';

type SidebarCollapseContextValue = {
  collapsed: boolean;
  setCollapsed: (collapsed: boolean) => void;
};

const SidebarCollapseContext = createContext<SidebarCollapseContextValue | null>(null);

export function SidebarCollapseProvider({ children }: { children: React.ReactNode }) {
  const [collapsed, setCollapsedState] = useState(false);

  useLayoutEffect(() => {
    setCollapsedState(readSidebarCollapsed());
  }, []);

  const value = useMemo(
    () => ({
      collapsed,
      setCollapsed: (next: boolean) => {
        writeSidebarCollapsed(next);
        setCollapsedState(next);
      },
    }),
    [collapsed],
  );

  return (
    <SidebarCollapseContext.Provider value={value}>{children}</SidebarCollapseContext.Provider>
  );
}

export function useSidebarCollapsed(): SidebarCollapseContextValue {
  const ctx = useContext(SidebarCollapseContext);
  if (!ctx) {
    throw new Error('useSidebarCollapsed requires SidebarCollapseProvider');
  }
  return ctx;
}
